import { MergeDomainConfig } from './types';

/**
 * Merge configuration for Therapeutic Areas domain
 */
export const THERAPEUTIC_AREAS_MERGE_CONFIG: MergeDomainConfig = {
  domainName: 'therapeutic-areas',
  entityIdField: 'therapeutic_area_id',
  entityNameField: 'therapeutic_area_name',
  relatedEntityName: 'products',
  apiBasePath: '/therapeutic_areas',
};

/**
 * Merge configuration for Grades domain
 */
export const GRADES_MERGE_CONFIG: MergeDomainConfig = {
  domainName: 'grades',
  entityIdField: 'grade_id',
  entityNameField: 'grade_name',
  relatedEntityName: 'products',
  apiBasePath: '/grades',
};

/**
 * Merge configuration for Manufacturers domain
 */
export const MANUFACTURERS_MERGE_CONFIG: MergeDomainConfig = {
  domainName: 'manufacturers',
  entityIdField: 'manufacturer_id',
  entityNameField: 'manufacturer_name',
  relatedEntityName: 'products', // Use products for generic fields (matches SQL)
  apiBasePath: '/manufacturers',
};

/**
 * Merge configuration for Facilities domain
 */
export const FACILITIES_MERGE_CONFIG: MergeDomainConfig = {
  domainName: 'facilities',
  entityIdField: 'facility_id',
  entityNameField: 'facility_name',
  relatedEntityName: 'products',
  apiBasePath: '/facilities',
};
